import { theme } from "@chakra-ui/theme"

export const getRandomColor = () => {
    const possibleColors = ["blue", "green", "red", "yellow", "orange", "teal", "cyan", "pink", "gray"];
    return possibleColors[Math.floor(Math.random() * possibleColors.length)];
}